import { MAX_TIME } from "@/__main__/constants.mjs";
import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/app-urls.mjs";
import type {
  Article,
  ArticlePreview,
  Latest,
} from "@/data-models/articles.mjs";
import {
  ArticleModel,
  ArticlePreviewModel,
  LatestModel,
} from "@/data-models/articles.mjs";

const EXPIRY = 24 * 60 * 60 * 1000;

export function getLatestNews(props?: { isStaging: boolean }): Promise<Latest> {
  const isStaging = props?.isStaging ?? false;
  // Clever method to ensure we maintain cache busting that matches search params and getData expiry time
  const version = isStaging ? Date.now() : new Date().setUTCHours(0, 0, 0, 0);
  const source = new URL(`${appURLs.CDN_PLAIN}/news/dec11`);
  source.searchParams.set("pragma", `${version}`);
  if (isStaging) source.pathname += "-staging";
  source.pathname += ".json";
  return getData(
    source.toString(),
    LatestModel,
    ["news", "latest", isStaging ? "staging" : "production"],
    {
      skipSafetyCheck: true,
      shouldFetchIfPathExists: true,
      expiryTime: isStaging ? undefined : version + EXPIRY,
      networkBackOffTime: isStaging ? 0 : undefined,
    },
  );
}

export function getArticle(filename: string): Promise<Article> {
  return getData(
    `${appURLs.CDN_PLAIN}/news/articles/${filename}`,
    ArticleModel,
    ["news", "articles", filename],
    {
      skipSafetyCheck: true,
      expiryTime: MAX_TIME,
    },
  );
}

export function getArticlePreview(filename: string): Promise<ArticlePreview> {
  return getData(
    `${appURLs.CDN_PLAIN}/news/preview/${filename}`,
    ArticlePreviewModel,
    ["news", "preview", filename],
    {
      skipSafetyCheck: true,
      expiryTime: MAX_TIME,
    },
  );
}
